import React from 'react';

function Nepal(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124034)">
        <rect width="36" height="24" fill="white" />
        <path
          d="M13.1352 12.342L23.5959 23.5H0.5V0.798095L22.5727 11.5H13.5H12.3459L13.1352 12.342Z"
          fill="#C51918"
          stroke="#4857A1"
        />
        <mask
          id="mask0_800_124034"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="24"
        >
          <path
            d="M13.1352 12.342L23.5959 23.5H0.5V0.798095L22.5727 11.5H13.5H12.3459L13.1352 12.342Z"
            fill="white"
            stroke="white"
          />
        </mask>
        <g mask="url(#mask0_800_124034)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.55833 20.0102L5.18002 21.6003L5.11639 19.5938L2.94986 20.16L4.22523 18.5035L2.09802 17.8296L4.22523 17.1558L2.94986 15.4992L5.11639 16.0655L5.18002 14.059L6.55833 15.649L7.93665 14.059L8.00027 16.0655L10.1668 15.4992L8.89144 17.1558L11.0186 17.8296L8.89144 18.5035L10.1668 20.16L8.00027 19.5938L7.93665 21.6003L6.55833 20.0102Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.52515 8.1388L5.80533 8.96921L5.7721 7.92131L4.64065 8.21704L5.3067 7.35191L4.19578 7L5.3067 6.64809L4.64065 5.78296L5.7721 6.07869L5.80533 5.03079L6.52515 5.8612L7.24496 5.03079L7.27819 6.07869L8.40965 5.78296L7.7436 6.64809L8.85452 7L7.7436 7.35191L8.40965 8.21704L7.27819 7.92131L7.24496 8.96921L6.52515 8.1388Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.37439 7.89411C8.879 7.903 10.2144 6.64001 10.2144 6.64001C10.4785 8.08117 8.4389 9.04001 6.3988 9.04001C4.3587 9.04001 3.12352 7.73299 2.36255 6.64001C2.36255 6.64001 3.86978 7.88521 6.37439 7.89411Z"
            fill="#F9FAFA"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124034">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Nepal;
